import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import { Spinner } from "react-bootstrap";
import { RouteTypes } from "./routes.props";
import LocalStorage from "../LocalStorage";

const Login = React.lazy(() => import("pages/Login"));

export function RenderRoutes({ routes }: { routes: RouteTypes[] }) {
    const token = LocalStorage.getAccessToken();

    return (
        <React.Suspense fallback={<Spinner animation="border" role="status" />}>
            <Switch>
                <Route
                    exact
                    path="/"
                    render={(props) =>
                        !token ? (
                            // @ts-ignore
                            <Login {...props} />
                        ) : (
                            <Redirect to={routes[0]?.subRoutes[0]?.path} />
                        )
                    }
                />
                {routes?.map((route) =>
                    route?.subRoutes.map((subRoute) => (
                        <Route
                            key={subRoute.key}
                            path={subRoute.path}
                            exact={subRoute.exact}
                            render={() =>
                                token ? (
                                    <subRoute.component {...subRoute} />
                                ) : (
                                    <Redirect to="/" />
                                )
                            }
                        />
                    ))
                )}
                <Route
                    render={() =>
                        !token ? (
                            <Redirect to="/" />
                        ) : (
                            <h1>page not found, 404!</h1>
                        )
                    }
                />
            </Switch>
        </React.Suspense>
    );
}
